// Zwei-Faktor-Anmeldung: reine Hilfen und die Anleitungstexte (1:1 aus dem PersoNYzer, Namen angepasst).
export const LOGIN_MERKZEICHEN = 'zwei_faktor_login_merkzeichen';
// Antwort von POST /auth/login einordnen. Ohne access_token und ohne zwei_faktor ist es ein Fehler.
export function loginErgebnis(daten) {
  const d = daten || {};
  if (d.access_token) return { art: 'fertig' };
  if ((d.zwei_faktor === 'erforderlich' || d.zwei_faktor === 'einrichtung_erforderlich') && d.zwischen_token) {
    return { art: 'zwei_faktor', zweiFaktor: d.zwei_faktor, zwischenToken: d.zwischen_token };
  }
  return { art: 'fehler' };
}
export function datumDE(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return new Intl.DateTimeFormat('de-DE', { timeZone: 'Europe/Berlin', day: '2-digit', month: '2-digit', year: 'numeric' }).format(d);
}
export function codesAlsText(codes, konto) {
  return [
    'TimeNYzer – Wiederherstellungscodes',
    konto ? `Konto: ${konto}` : null,
    'Jeder Code funktioniert genau einmal. Bitte ausdrucken oder im Passwort-Manager speichern, nicht im WhatsApp-Chat.',
    '',
    ...(codes || []),
    '',
  ].filter((z) => z !== null).join('\n');
}
// Nur 6 ASCII-Ziffern (App-Code) oder ein Wiederherstellungscode (10 Zeichen, Bindestrich egal).
export function codeGueltig(code) {
  const c = (code || '').replace(/\s/g, '');
  return /^[0-9]{6}$/.test(c) || /^[a-zA-Z0-9]{5}-?[a-zA-Z0-9]{5}$/.test(c);
}
// **fett** → Segmente; ohneFett() für Stellen, die nur Text zeigen.
export function fettTeile(text) {
  return String(text).split('**').map((teil, i) => ({ teil, fett: i % 2 === 1 }));
}
export const ohneFett = (text) => String(text).split('**').join('');
// Eine empfohlene App, Store-Adressen wörtlich.
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2';
export const APP_STORE_URL = 'https://apps.apple.com/de/app/google-authenticator/id388497605';
// iPad mit Desktop-Kennung meldet sich als „Macintosh“, hat aber einen Touchscreen.
export function handyArt(userAgent, maxTouchPoints) {
  const ua = userAgent || '';
  if (/Android/i.test(ua)) return 'android';
  if (/iPhone|iPad|iPod/.test(ua)) return 'iphone';
  if (/Macintosh/.test(ua) && (maxTouchPoints || 0) > 1) return 'iphone';
  return 'pc';
}
export const STORE = {
  android: { url: PLAY_STORE_URL, knopf: 'Im Play Store öffnen', qr: '/zweifaktor/playstore-qr.svg', name: 'Play Store' },
  iphone: { url: APP_STORE_URL, knopf: 'Im App Store öffnen', qr: '/zweifaktor/appstore-qr.svg', name: 'App Store' },
};
export const APP_SYMBOL = '/zweifaktor/google-authenticator.png';
export const STORE_QR_SATZ = 'Scannen Sie diesen Code mit der Kamera Ihres Handys – dann öffnet sich der Store direkt.';
export const ANDROID_SCHRITTE = [
  'Tippen Sie auf **„Im Play Store öffnen"** oder scannen Sie den Code mit der Handy-Kamera.',
  'Tippen Sie auf **„Installieren"**. Achten Sie auf den Namen **„Google Authenticator"** von **Google LLC**.',
  'Öffnen Sie die App und tippen Sie auf **„Jetzt starten"**.',
  'Die App fragt nach Ihrem Google-Konto. Tippen Sie auf **„Ohne Konto verwenden"** oder melden Sie sich an – beides funktioniert.',
];
export const IPHONE_SCHRITTE = [
  'Tippen Sie auf **„Im App Store öffnen"** oder scannen Sie den Code mit der Handy-Kamera.',
  'Tippen Sie auf **„Laden"** und bestätigen Sie mit Face ID, Touch ID oder Ihrem Apple-Passwort. Achten Sie auf den Namen **„Google Authenticator"** von **Google LLC**.',
  'Öffnen Sie die App und tippen Sie auf **„Jetzt starten"**.',
  'Die App fragt nach Ihrem Google-Konto. Tippen Sie auf **„Ohne Konto verwenden"** oder melden Sie sich an – beides funktioniert.',
];
const OHNE_STORE_QR = ' oder scannen Sie den Code mit der Handy-Kamera';
// Am Handy gibt es keinen Store-QR: dort entfällt der Hinweis aufs Scannen im 1. Schritt.
export function appSchritte(reiter, art) {
  const liste = reiter === 'iphone' ? IPHONE_SCHRITTE : ANDROID_SCHRITTE;
  return art === 'pc' ? liste : [liste[0].replace(OHNE_STORE_QR, ''), ...liste.slice(1)];
}
export const VERBINDEN_SCHRITTE = [
  'Tippen Sie in der App auf **„QR-Code scannen"**. Stehen schon andere Codes in der App, tippen Sie zuerst unten rechts auf das **„+"**.',
  'Fragt das Handy nach der Kamera, erlauben Sie den Zugriff.',
  'Halten Sie die Kamera auf den QR-Code hier auf dem Bildschirm. Die App zeigt dann „TimeNYzer" mit einer 6-stelligen Zahl.',
  'Tippen Sie hier auf **„Weiter"**.',
];
export const HANDY_HINWEIS = 'Sie sind am Handy? Dann können Sie den QR-Code nicht scannen – so geht es trotzdem:';
export const SCHLUESSEL_SCHRITTE = [
  'Schlüssel kopieren.',
  'In der App auf **„+"** → **„Einrichtungsschlüssel eingeben"** tippen.',
  'Konto: **TimeNYzer**, Schlüssel: einfügen, „Zeitbasiert" so lassen.',
  '**„Hinzufügen"** tippen.',
];
export const ZAHL_TEXT = 'Tippen Sie die 6-stellige Zahl ein, die in der App unter „TimeNYzer" steht. Sie wechselt alle 30 Sekunden – nehmen Sie einfach die aktuelle.';
export const UHRZEIT_HINWEIS = 'Klappt es nicht? Warten Sie auf die nächste Zahl. Hilft das nicht: Stellen Sie am Handy Datum und Uhrzeit auf **automatisch**.';
export const GESCHAFFT = 'Geschafft – die App ist verbunden. Ab jetzt melden Sie sich mit Passwort **und** der Zahl aus der App an.';
export const DRUCK_BLOCKIERT = "Das Druckfenster wurde blockiert. Bitte nutzen Sie 'Als Textdatei speichern'.";
export const GUT_ZU_WISSEN = [
  'Andere Apps gehen auch: **Microsoft Authenticator** oder am iPhone die App **„Passwörter"**.',
  '**Wiederherstellungscodes** bitte ausdrucken oder im Passwort-Manager speichern, **nicht** im WhatsApp-Chat.',
  '**Neues Handy:** Tippen Sie in „Profil → Sicherheit" auf „Authenticator-App", solange das alte Handy noch da ist.',
  '**Handy verloren:** Nutzen Sie einen Wiederherstellungscode oder bitten Sie die Geschäftsführung bzw. den Admin, die Zwei-Faktor-Anmeldung zurückzusetzen.',
];
// Anleitung zum Nachlesen (ersetzt die Hilfeartikel des PersoNYzer).
export const ZWEI_FAKTOR_START = 'So starten Sie: Klicken Sie oben rechts auf Ihren Namen → Profil → Sicherheit → „Zwei-Faktor-Anmeldung".';
export const DASSELBE_HANDY = 'Nutzen Sie TimeNYzer auf demselben Handy, mit dem Sie den Code erzeugen? Dann zeigt der Assistent statt des QR-Codes einen Schlüssel zum Kopieren – so geht es ohne Scannen.';
export const EINRICHTEN_LINK = '/profile?einrichten=1';
// Erinnerungsfenster: nur Verwaltung, Stand geladen und 2FA aus, kein Passwortzwang,
// dazu Login-Merkzeichen oder fällig (spätestens alle 7 Tage). aktiv === undefined heißt „noch nicht geladen".
export function erinnerungZeigen({ verwaltung, aktiv, faellig, merkzeichen, mustChangePassword }) {
  if (!verwaltung || mustChangePassword || aktiv !== false) return false;
  return Boolean(merkzeichen || faellig);
}
